export default "__VITE_ASSET__EyESQGSq__"